<template>
  <div>
    <div class="col-12" style="padding: 0">
      <div
        class="row mb-2 mt-2"
        style="justify-content: space-between; margin: auto"
      >
        <div class="team-title d-flex" style="padding-left: 1.3rem">
          <i class="material-icon-font material-icons user-font mr-2"
            >work_outline</i
          >
          <div style="margin-top: auto; margin-bottom: auto">
            Import portfolio
          </div>
        </div>
      </div>
    </div>
    <div
      id="drop_root"
      v-if="!Object.keys(fileObj).length > 0 && !isShow"
      v-cloak
      @drop.prevent="addFile"
      @dragover.prevent
    >
      <pre>
      <div id="drop" style="font-family: 'Comfortaa', cursive;"><i class="nc-icon nc-cloud-upload-94" style="margin-bottom: 20px; font-size: 2em;"></i><br />Drag file to upload here</div>
      <div
  style="margin-bottom: 0px; padding-bottom: 0px;font-size: 15px;text-align:center"
>Would you like to add companies by uploading a spreadsheet?<span
  style="color:#5445F3;cursor:pointer"
  @click="downloadURL"
> Click here</span> to download a format to fill in and upload.</div>
      <div
  style="margin-top: 0px; margin-bottom: 0px; padding-top: 0px; position: relative; top: -20px;text-align:center"
><input type="file" accept=".xlsx" name="xlfile" id="xlf" class /><!--btn btn-info btn-fill btn-wd--></div>
      <!-- <div
  style="margin-bottom: 0px; margin-top: 0px; adding-bottom: 0px; position: relative; top: -35px;"
>Note: Uploading a new Excel will overwrite any saved data. At anytime you want to start over, select "My Profile" from the menu.</div> -->
      <div></div>
    </pre>
      <pre id="out"></pre>
      <div id="htmlout"></div>
    </div>
    <div v-else>
      <div class="importDiv">
        <div class="importText">
          <div>
            Now let’s match the columns in your uploaded file to your fiifi
            Account.
          </div>
          <div>See an example of the import field match process.</div>
        </div>
        <div class="d-flex" v-if="unmatchedCount > 0">
          <div class="unmatchedCountText">
            {{ unmatchedCount }} unmatched columns
          </div>
          <div class="d-flex">
            <input
              type="checkbox"
              class="regular-checkbox"
              style="cursor: pointer"
              @change="filterUnmatched"
            />
            <div class="unmatchedCheckBox">Show unmatched columns</div>
          </div>
        </div>
      </div>
      <div class="style-4" style="overflow-x: auto; overflow-y: hidden">
        <div class="d-flex importCardsDiv">
          <div
            v-for="(value, headerKey) in fileObj"
            :key="headerKey"
            :class="fileObj[headerKey].displayCheck ? 'mr-4' : ''"
          >
            <div
              class="importHeaderCard"
              :style="
                fileObj[headerKey].status ? 'background-color:#F2FFEF' : ''
              "
              v-if="fileObj[headerKey].displayCheck"
            >
              <div class="import-header-div">
                <b-dropdown
                  id="dropdown-offset"
                  toggle-class="text-decoration-none import-header-dpdwn"
                  class="style-5"
                >
                  <template v-slot:button-content>
                    <div
                      class="import-header-button"
                      :style="
                        fileObj[headerKey].status
                          ? 'background-color:#F2FFEF'
                          : ''
                      "
                    >
                      {{ fileObj[headerKey].mappingFieldLabel }}
                    </div>
                  </template>
                  <b-dropdown-item
                    href="#"
                    v-for="(field, itemIndex) in importHeaders"
                    :key="itemIndex"
                    :disabled="field.isMatched"
                    @click="
                      fieldSelected(
                        field,
                        headerKey,
                        fileObj[headerKey].mappingFieldValue
                      )
                    "
                  >
                    <div :style="field.isMatched ? 'color:#9D9D9D;' : ''">
                      {{ field.label }}
                      <span class="required" v-if="field.value == 'company_url'"
                        >*</span
                      >
                    </div>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <div
                class="mapStatusBtn"
                :style="
                  fileObj[headerKey].status
                    ? 'color: #0EBA00;'
                    : 'color: #FF7474;'
                "
              >
                ({{
                  fileObj[headerKey].status ? "matched" : "unmatched column"
                }})
              </div>
              <div
                v-for="(headers, index) in fileObj[headerKey].data.slice(
                  0,
                  fileObj[headerKey].data.length > 5
                    ? 5
                    : fileObj[headerKey].data.length
                )"
                :key="index"
              >
                <div v-if="index < 6" class="import-data-item">
                  {{ headers ? headers : "-" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-5 mb-3">
        <div class style="padding-left: 2rem">
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click="
              handleCancel();
              fileObj = {};
              $router.go(-1);
            "
          >
            Cancel
          </button>
        </div>
        <div class style="padding-left: 1.5rem">
          <button
            type="button"
            class="todo-form-submit-button btn btn-primary"
            @click.prevent="importSubmit()"
            style="width: 135px"
            :disabled="isSaving"
          >
            Save <span v-if="isSaving">{{ savePercent }}%</span>
            <b-spinner
              v-if="isSaving"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </div>
    <el-dialog
      left
      title="Import Portfolio"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      @close="handleCancel()"
      :visible.sync="isShow"
      width="450px"
      style="margin: 0 auto"
      class="importModal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div>
        <div v-if="!importStatus">
          <div class="d-flex" style="margin-bottom: 20px">
            <div class="importImgDiv">
              <img
                class="suggestionConnectionImages"
                src="https://assets.fiifi-dev.com/importExcel.png"
              />
            </div>
            <div class="ml-2 mt-1">
              <div>{{ fileDetails.name }}</div>
              <div>{{ bytesToSize(fileDetails.size) }}</div>
            </div>
          </div>
          <!-- <b-progress
            class="importProgress"
            :value="value"
            height="10px"
            :label="`${value}%`"
            :max="max"
            show-value
          ></b-progress> -->
        </div>
        <div v-else>
          <div class="importMsgStatus">Portfolio Import Successfully !</div>
        </div>
        <div
          class="col-xl edit-company-action-button-row"
          style="padding: 0px; margin-top: 30px"
        >
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click="
              handleCancel();
              fileObj = {};
              $router.go(-1);
            "
          >
            Cancel
          </button>
          <button
            type="button"
            :disabled="!importStatus"
            class="todo-form-submit-button btn btn-primary"
            @click="
              isShow = false;
              value = 0;
            "
          >
            <b-spinner
              v-if="!importStatus"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
            Done
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import swal from "sweetalert2";
import NotificationSample from "../Components/NotificationSample";
const excelToJson = require("convert-excel-to-json");
import { vals } from "../../../util";
import { Select, Option } from "element-ui";
import { Dialog } from "element-ui";
import { Company } from "../../../models/Company";
const fs = require("fs");
const util = require("util");
import { mapGetters } from "vuex";
const _ = require("lodash");
import moment from "moment";
import api from "../../../axios_api";
import postscribe from "postscribe";
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog,
  },
  computed: {
    moment() {
      return moment;
    },
    unmatchedCount() {
      let count = 0;
      let fileObj = JSON.parse(JSON.stringify(this.fileObj));
      for (var key in fileObj) {
        if (!fileObj[key].status) count++;
      }
      return count;
    },
    checkUrlGiven() {
      let headers = this.importHeaders;
      let index = headers.findIndex(
        (item) => item.value == "company_url" && item.isMatched == true
      );
      if (index >= 0) return false;
      else return true;
    },
  },
  data() {
    return {
      importHeaders: JSON.parse(JSON.stringify(vals.IMPORT_HEADERS)),
      fileObj: {},
      isSaving: false,
      isShow: false,
      fileDetails: {},
      importStatus: false,
      max: 100,
      value: 0,
      referrerArray: [],
      referrerIndex: 0,
      responseReferrer: [],
      boundary: "window",
      unmatchedFilter: false,
      chunkSize: 20,
      chunkCount: 0,
      dataToSave: [],
      savePercent: 0,
    };
  },
  methods: {
    downloadURL() {
      window.open(
        "https://www.dropbox.com/s/i0y6cmzot51vzyn/ExampleXLS_0.2.xlsx?dl=1"
      );
    },
    filterUnmatched(e) {
      if (e.target.checked) {
        for (let key in this.fileObj) {
          if (!this.fileObj[key].status) {
            this.fileObj[key].displayCheck = true;
          } else {
            this.fileObj[key].displayCheck = false;
          }
        }
      } else {
        for (let key in this.fileObj) {
          this.fileObj[key].displayCheck = true;
        }
      }
    },
    handleCancel() {
      this.importStatus = false;
      this.isShow = false;
      this.value = 0;
    },
    importSubmit() {
      let self = this;
      this.isSaving = true;
      let companies = {};
      for (var key in this.fileObj) {
        if (this.fileObj[key].status) {
          let data = this.fileObj[key].data;
          data.map((item, index) => {
            if (!companies[index]) companies[index] = new Company({});
            companies[index] = {
              ...companies[index],
              [this.fileObj[key].mappingFieldValue]: item,
            };
          });
        }
      }
      let payload = Object.values(companies);
      self
        .checkDataValidation(payload)
        .then((data) => {
          self.$notify({ component: NotificationSample, timeout: 300000 });

          self.chunkCount = 0;
          self.dataToSave = payload;
          self.savePercent = 0;
          self.uploadCompanyData();
        })
        .catch((err) => {
          this.isSaving = false;
          if (err && err.length > 0) {
            let html = "";
            err.map((item, index) => {
              html += `<div>${item}</div>`;
            });
            swal({
              title: "Validation Error",
              html,
              buttonsStyling: false,
              confirmButtonClass: "swal-danger-btn btn-danger btn-fill",
            });
          }
        });
    },
    uploadCompanyData() {
      let self = this;

      self.$store
        .dispatch(
          "portfolio/apiPostPortfolio",
          self.dataToSave.slice(
            self.chunkCount,
            self.chunkCount + self.chunkSize
          )
        )
        .then((ret) => {
          self.chunkCount += self.chunkSize;

          self.savePercent = Math.floor(
            (self.chunkCount * 100) / self.dataToSave.length
          );
          if (self.savePercent > 100) {
            self.savePercent = 100;
          }

          if (self.chunkCount < self.dataToSave.length) {
            self.uploadCompanyData();
          } else {
            self.finishedUpload(ret.data, undefined, self.dataToSave);
          }
        })
        .catch((err) => {
          console.log(err);
          self.finishedUpload(undefined, err.payload, self.dataToSave);
        });
    },
    finishedUpload(validation, err, payload) {
      let self = this;
      this.isSaving = false;
      if (!validation || (err && !_.isEmpty(err))) {
        console.error(`${util.inspect(err)}`);
        swal({
          title: "Server Error",
          buttonsStyling: false,
          confirmButtonClass: "swal-danger-btn btn-danger btn-fill",
          text:
            "There was an error uploading your data to the server. Please try again. If you continue to receive errors, please contact support.",
        });
      } else {
        let verrs = _.reduce(
          validation.errors,
          (m, v) => {
            return `${v.message}\n` + m;
          },
          ""
        );
        // generate html from our validation error and counts
        let html = "";
        html += `<p>Imported ${validation.success}/${
          validation.success + validation.fail
        } companies</p>`;
        if (validation.errors.length > 0) {
          html += `<p>There were errors in your xls sheet (see below)</p>`;
          html += "<p>";
          _.each(validation.errors, (e) => {
            html += `${e.message}<br />`;
          });
          html += "</p>";
        }

        let insertedData = validation.encrypt.data,
          referrerArray = [];
        if (insertedData.length > 0) {
          payload.map((item, index) => {
            if (
              (item.referred_by_name || item.referred_by_email) &&
              item.company_url
            ) {
              let insertedId = insertedData.find((insertItem) => {
                if (
                  insertItem &&
                  insertItem.company_url &&
                  insertItem.company_url.toLowerCase() ==
                    item.company_url.toLowerCase()
                )
                  return insertItem;
              });
              if (insertedId && insertedId._id) {
                let referrerPayload = {
                  _id: insertedId._id,
                  referred_by_name: item.referred_by_name,
                  referred_by_email: item.referred_by_email,
                };
                referrerArray.push(referrerPayload);
              }
            }
          });
          if (referrerArray.length > 0) {
            self.referrerArray = referrerArray;
            self.referrerIndex = 0;
            self.insertReferrers();
          } else {
            self.navigatePortfolio();
          }
        } else {
          self.navigatePortfolio();
        }
      }
    },
    navigatePortfolio() {
      let self = this;
      this.isSaving = false;
      this.$notifyClear();
      this.$store.dispatch("suggestions/getSuggestions");
      this.$store.dispatch("diligence/apiCleanFetchDiligence");
      this.$store.dispatch("contacts/getContacts");
      this.$store.dispatch("investment/start");
      if (self.referrerArray) this.$store.dispatch("referrer/start");
      self.$router.push(
        `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/portfolio?new=true`
      );
    },
    insertReferrers() {
      let self = this;
      api
        .post(
          `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/portfolio/referrer`,
          { encrypt: { data: self.referrerArray[self.referrerIndex] } }
        )
        .then((insertedreferrer) => {
          self.responseReferrer.push(insertedreferrer);
          self.referrerIndex++;
          if (
            self.referrerIndex == self.referrerArray.length &&
            self.responseReferrer.length == self.referrerArray.length
          ) {
            self.navigatePortfolio();
          } else {
            self.insertReferrers();
          }
        })
        .catch((err) => {
          console.log({ err });
        });
    },
    hasNumbers(t) {
      var regex = /\d/g;
      return regex.test(t);
    },
    isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    checkDataValidation(data) {
      return new Promise((resolve, reject) => {
        let err = [];
        let self = this;
        let payload = JSON.parse(JSON.stringify(data));
        payload.map((companyItem, index) => {
          for (var key in companyItem) {
            if (companyItem[key] && companyItem[key].length > 0) {
              if (
                key.toLowerCase() == "referred_by_email".toLowerCase() ||
                key.toLowerCase() == "ceo_email".toLowerCase()
              ) {
                if (
                  companyItem[key] &&
                  companyItem[key].split("@").length != 2
                ) {
                  err.push(
                    `Validation failed: Email format at line ${index + 1}`
                  );
                }
              }
              if (vals.STRING_HEADERS.indexOf(key) >= 0) {
                if (key.toLowerCase() == "stage".toLowerCase()) {
                  // if (!vals.STAGE_DEFINES.indexOf(companyItem[key]) >= 0) {
                  //   err.push(
                  //     `Validation failed: No such stage ${
                  //       companyItem[key]
                  //     } at index ${index + 1}`
                  //   );
                  // }
                } else {
                  let regex = /^[0-9]*[.]?[0-9]*$/;
                  if (regex.test(companyItem[key])) {
                    err.push(
                      `Validation failed: For ${key} at line ${index + 1}`
                    );
                  }
                }
              }
              if (vals.DATE_HEADERS.indexOf(key) >= 0) {
                if (
                  companyItem[key].split("/").length != 3 ||
                  new Date(companyItem[key]).toString().includes("nvalid")
                )
                  err.push(
                    `Validation failed: Date should be in 'MM/DD/YYYY' for ${key} at line ${
                      index + 1
                    }`
                  );
              }
              if (vals.NUMBER_HEADERS.indexOf(key) >= 0) {
                companyItem[key] = companyItem[key].replace(/[$,%]/g, "");
                if (self.isNumeric(companyItem[key])) {
                  if (key.toLowerCase() == "ownership".toLowerCase()) {
                    if (companyItem[key] > 100)
                      err.push(
                        `Validation failed:Ownership cannot be greater than 100 at line ${
                          index + 1
                        }`
                      );
                  }
                } else {
                  err.push(`Validation failed:For ${key} at line ${index + 1}`);
                }
              }
            }
            if (
              index == payload.length - 1 &&
              Object.keys(companyItem)[Object.keys(companyItem).length - 1] ==
                key
            ) {
              if (err && err.length > 0) reject(err);
              else resolve("Validation done");
            }
          }
        });
      });
    },
    fieldSelected(field, selectedKey, oldValue) {
      if (oldValue && oldValue.length > 0) {
        for (var key in this.fileObj) {
          if (
            this.fileObj[key] &&
            this.fileObj[key].mappingFieldValue == oldValue
          ) {
            this.fileObj[key].mappingFieldValue = "";
            this.fileObj[key].mappingFieldLabel = key;
            this.fileObj[key].status = false;
          }
        }
      }
      this.fileObj[selectedKey].mappingFieldLabel = field.label;
      this.fileObj[selectedKey].mappingFieldValue = field.value;
      this.fileObj[selectedKey].status = true;
      this.importHeaders.map((item) => (item.isMatched = false));
      for (var key in this.fileObj) {
        if (this.fileObj[key].mappingFieldValue) {
          this.importHeaders.map((item) => {
            if (item.value == this.fileObj[key].mappingFieldValue) {
              item.isMatched = true;
            }
          });
        }
      }
    },
    findDuplicatesHeaders(arr) {
      return arr.filter((item, index) => arr.indexOf(item) != index);
    },
    mapData(sheet) {
      this.fileObj = {};
      let headers = [];
      if (!sheet || Object.keys(sheet).length <= 0) {
        this.$toaster.error(
          "We are unable to load your data...Please try again importing valid file"
        );
        this.handleCancel();
        this.$router.go(-1);
        return;
      }
      sheet = sheet[Object.keys(sheet)[0]];
      headers = sheet.shift();
      if (headers.length > 0) {
        let headersUniqueCheck = this.findDuplicatesHeaders(headers);
        if (headersUniqueCheck.length > 0) {
          this.$toaster.error(
            "We found some conflicts in your headers data..Please provide unique headers"
          );
          this.handleCancel();
          this.$router.go(-1);
          return;
        }
      }
      if (sheet.length <= 0) {
        this.$toaster.error(
          "We are unable to load your data...Please try again importing valid file"
        );
        this.handleCancel();
        this.$router.go(-1);
        return;
      }
      let temp = sheet;
      let obj = {};
      let maxLength = 0;
      let importHeaders = JSON.parse(JSON.stringify(this.importHeaders));
      temp = temp.filter((item) => item.length > 0);
      //Find the max length in the arrays of array.
      let arraySort = JSON.parse(JSON.stringify(temp));
      arraySort.sort((a, b) => b.length - a.length);
      maxLength = arraySort[0].length;
      //If for any particular array having less value count(for continuosuly row null excepty url) then add null
      temp.map((item) => {
        if (item.length < maxLength) {
          var diff = maxLength - item.length;
          for (i = 0; i < diff; i++) {
            item.push(null);
          }
        }
      });
      let untitledIndex = 1;
      for (var i = 0; i < temp.length; i++) {
        this.value += 1;
        for (var j = 0; j < temp[i].length; j++) {
          if (!headers[j]) {
            headers[j] = `Untitled${untitledIndex}`;
            untitledIndex++;
          }
          if (!obj[headers[j]]) {
            let index = -1;
            index = importHeaders.findIndex(
              (item) => item.label.toLowerCase() == headers[j].toLowerCase()
            );
            if (index >= 0) {
              this.importHeaders[index].isMatched = true;
            }
            obj[headers[j]] = {
              data: [],
              mappingFieldLabel:
                index < 0 ? headers[j] : importHeaders[index].label,
              mappingFieldValue: index < 0 ? "" : importHeaders[index].value,
              status: index < 0 ? false : true,
              displayCheck: true,
            };
          }

          if (headers[j]) {
            switch (headers[j].toLowerCase()) {
              case "current stage":
                obj[headers[j]].data.push(this.fixStage(temp[i][j]));
                break;
              case "geography":
              case "sector":
              case "status":
              case "direct/lp":
              case "founder gender":
                obj[headers[j]].data.push(
                  temp[i][j] ? temp[i][j].toString().initCap() : temp[i][j]
                );
                break;
              default:
                obj[headers[j]].data.push(temp[i][j]);
                break;
            }
          } else {
            obj[headers[j]].data.push(temp[i][j]);
          }

          if (i == temp.length - 1 && j == temp[i].length - 1) {
            this.importStatus = true;
            this.value = 100;
          }
        }
      }
      this.fileObj = obj;
    },
    fixStage(str) {
      if (!str) {
        return str;
      }
      switch (str.toString().toLowerCase()) {
        case "pre seed":
        case "pre-seed":
          return "Pre-seed";
          break;
        default:
          return str.toString().initCap();
          break;
      }
    },
    bytesToSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    parseFile(oFile) {
      let self = this;
      self.isShow = true;
      self.value = 5;
      self.fileDetails = oFile;
      var sFilename = oFile.name;
      var reader = new FileReader();
      var result = {};
      reader.onload = function (e) {
        var data = e.target.result;
        data = new Uint8Array(data);
        var workbook = XLSX.read(data, { type: "array" });
        var result = {};
        workbook.SheetNames.forEach(function (sheetName) {
          var roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) result[sheetName] = roa;
        });
        // see the result, caution: it works after reader event is done.
        self.mapData(result);
      };
      reader.readAsArrayBuffer(oFile);
    },
    addFile(e) {
      let self = this;
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;

      for (let i = 0; i < droppedFiles.length; i++) {
        const names = droppedFiles[i].name.split(".");
        if (names[names.length - 1].toLowerCase() !== "xlsx") {
          this.$toaster.error(
            "Please upload a spreadsheet with .xlsx extension."
          );
          return;
        }
      }

      [...droppedFiles].forEach((f) => {
        self.parseFile(f);
      });
    },
  },
  mounted() {
    let self = this;
    const input = document.getElementById("xlf");
    input.addEventListener("change", () => {
      const names = input.files[0].name.split(".");
      if (names[names.length - 1].toLowerCase() !== "xlsx") {
        self.$toaster.error(
          "Please upload a spreadsheet with .xlsx extension."
        );
        input.value = "";
        return;
      }

      self.parseFile(input.files[0]);
    });
  },
};
</script>
<style>
.style-5 .dropdown-menu {
  max-height: 315px;
  overflow-y: auto;
}
#drop {
  border: 2px dashed #bbb;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  padding: 25px;
  text-align: center;
  font: 20pt bold, "Vollkorn";
  color: #bbb;
}

#b64data {
  width: 100%;
}
a {
  text-decoration: none;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  position: absolute;
  z-index: -1;
}
.swal-danger-btn {
  border-radius: 4px;
  width: 65px;
  height: 32px;
}
.importHeaderCard {
  width: 100%;
  min-width: 200px;
  position: relative;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 3px #8b7e7e29;
  border-radius: 3px;
}
.import-header-dpdwn {
  margin-left: auto;
  margin-right: auto;
  padding: 0px;
  width: 165px;
  background-color: transparent !important;
}
.import-header-div {
  display: flex;
  justify-content: center;
  padding-top: 15px;
}

.import-header-div .btn {
  border: 0 !important;
}
.import-header-div .dropdown-menu {
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #d5d5d5;
}

.import-header-button {
  color: #000;
  background: #ffffff 0% 0% no-repeat padding-box !important;
  border: 1px solid #707070;
  border-radius: 2px;
  padding-left: 10px;
  text-align: left;
  padding: 7px;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
  padding-right: 16px;
}

.import-header-dpdwn::after {
  margin-right: 15px !important;
}
.mapStatusBtn {
  padding-top: 15px;
  padding-left: 20px;
  padding-bottom: 25px;
  border-bottom: 1px solid #dbdbdb4d;
  font-size: 14px;
}

.import-data-item {
  padding: 5px 15px;
  border-bottom: 1px solid #dbdbdb4d;
  white-space: nowrap;
  width: 210px;
  overflow: hidden;
  color: #414141;
  font-size: 12px;
  line-height: 25px;
  text-overflow: ellipsis;
}

.style-4::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #f5f5f5;
  height: 6px !important;
  border-radius: 10px !important ;
}

.style-4::-webkit-scrollbar {
  width: 8px;
  height: 6px !important;
  border-radius: 10px !important ;
}

.style-4::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: #5445f3 0% 0% no-repeat padding-box;
  height: 6px !important;
  border-radius: 10px !important ;
}
.importImgDiv {
  width: 55px;
  height: 55px;
}

.importProgress .progress-bar {
  background: #5445f3 0% 0% no-repeat padding-box;
  border-radius: 7px;
}

.importText {
  padding-bottom: 12px;
}
.unmatchedCountText {
  color: #ff5555;
  margin-right: 66px;
}
.importDiv {
  padding-left: 1.3rem;
  padding-top: 15px;
  padding-bottom: 15px;
}
.unmatchedCheckBox {
  margin-top: auto;
  margin-left: 6px;
  margin-bottom: auto;
}

.importCardsDiv {
  margin-left: 1.3rem;
  padding-bottom: 85px;
  min-height: 380px;
}
</style>
